<template>
  <div></div>
  <!-- <div class="Baidu-Map"
    v-loading="loading"
    element-loading-text="地图加载中..."
    element-loading-spinner="el-icon-phone-outline"
    element-loading-background="rgba(0, 0, 0, 0.7)">
    <div ref="planMap" id="baidu-map" class="Plan-Map"></div>
  </div> -->
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// import { initMap } from "@/assets/baiduMapKey/BaiduMapKey"
// import RadarOverlay from "./RadarOverlay"
// import { dateUtil } from "@/mixins/dateUtil";
// import Api from "@/components/Api/index"
// export default {
//   name:  '',
//   components: {

//   },
//   mixins:[dateUtil],
//   // 定义属性
//   data() {
//     return {
//       ak: "sLh8ZFChXHODuBNk2YtAiIXBiBQpO3to",
//       checkBudgets: {},
//       planMap: '',
//       stateMap: '',
//       cityIndex: 0,
//       loading: false
//     }
//   },
//   // 计算属性，会监听依赖属性值随之变化
//   computed: {},
//   // 监控data中的数据变化
//   watch: {},
//   // 方法集合
//   methods: {
//     _getCityPoint(cityArr) {
//       let points = []
//       cityArr.forEach(item => {
//         points.push([item.longitude,item.latitude])
//       })
//       return points;
//     },
//     /**
//      * 获取城市下库存信息
//      * @param {} cityId 告知要查询哪个城市的信息
//      */
//     _getStockList(cityIndex,state,center) {
//       this.cityIndex = cityIndex
//       console.log('hjdshfgjgfg',this.checkBudgets,cityIndex,state)
//       let _find = this.checkBudgets.cityList[cityIndex]
//       // if (center) {
//       //   this.planMap.setCenter(new BMapGL.Point(center.lng,center.lat))
//       // } else {
//       //   this.planMap.setCenter(new BMapGL.Point(_find.longitude,_find.latitude))
//       // }
//       var bounds = this.planMap.getBounds(); //得到地图边界有maxx minx maxy miny
//       // 左下角坐标(mp.getBounds().getSouthWest().lng, mp.getBounds().getSouthWest().lat)
//       // 右下角坐标(mp.getNorthEast().getNorthEast().lng, mp.getBounds().getNorthEast().lat)
//       // 中心坐标(mp.getCenter().lng, mp.getCenter().lat)
//       console.log('左下角坐标',bounds.getSouthWest().lng,bounds.getSouthWest().lat)
//       console.log('右下角坐标',bounds.getNorthEast().lng,bounds.getNorthEast().lat)
//       if (_find) {
//         //this.planMap.clearOverlays();
//         let planDay = this.dateFormatYMD(this.checkBudgets.planDate,"-")
//         let addDay = this.dateAddDay(this.checkBudgets.planDate,1)
//         let endDay = this.dateFormatYMD(addDay.getTime(),"-")
//         // this.loading = true
//         let query =
//         {
//           "page": 1,
//           "size": 100,
//           "q": {
//             "cityId": _find.cityId,
//             "cityName": null,
//             "cityNameCn": _find.cityName,
//             "cityNameEn": _find.cityNameEn,
//             "countryId": _find.countryId,
//             "date": [planDay, endDay],
//             "star": null,
//             "location": null,
//             "searchHotelPrice": null,
//             "keyword": _find.cityName,
//             "productType": 3,
//             "state": state,
//             "startDate": planDay,
//             "endDate": endDay,
//             "key": "",
//             "mapSpuShowRequest": {
//               "cityName": _find.cityName,
//               "minlat": bounds.getSouthWest().lat,
//               "minlng": bounds.getSouthWest().lng,
//               "maxlat": bounds.getNorthEast().lat,
//               "maxlng": bounds.getNorthEast().lng,
//               "centerlat": this.planMap.getCenter().lat,
//               "centerlng": this.planMap.getCenter().lng,
//               "state": state
// 		        },
//           }
//         }
//         //获取库存数据（自有库存）
//         new Api("resource").stockMapList(query).then(res => {
//           if (res.status == 200) {
//             //先清除地图上的自定义覆盖物
//             res.data.forEach(item => {
//               const point = new BMapGL.Point(item.longitude,item.latitude);
//               const marker = new RadarOverlay(point,this.stateMap,item,this.checkBudgets);
//               this.planMap.addOverlay(marker); // 将标注添加到地图中
//             })
//           }
//           setTimeout(() => {
//             this.loading = false
//           }, 500);

//           // this.initMap(this.stateMap,this.checkBudgets,,false)
//         }).catch(err => {
//           this.loading = false
//         })
//         //TODO 获取库存数据（爬虫数据）
//       }

//     },
//     //移除自定义覆盖物
//     removeMarker() {
//       const allOverlays = this.planMap.getOverlays()
//       console.log(allOverlays,'kdjsfgkdjk')
//       for (const item of allOverlays) {
//         this.planMap.removeOverlay(item);
//       }
//     },

//     // 设置中心点
//     setCenter(cityIndex) {
//       console.log("setCenter")
//       this.cityIndex = cityIndex
//       // 创建中心点
//       let _find = this.checkBudgets.cityList[this.cityIndex]
//       const point = new BMapGL.Point(_find.longitude,_find.latitude);
//       // 初始化地图，设置中心点坐标和地图级别
//       this.planMap.setCenter(point);
//       this._getStockList(this.cityIndex,this.stateMap.state,'')
//     },

//     // 地图的初始化
//     initMap(stateMap,checkBudgets){
//       this.loading = true
//       this.checkBudgets = checkBudgets
//       this.stateMap = stateMap
//       const _bodyHeight = document.body.clientHeight
//       const _newNavbar = document.getElementsByClassName("newNavbar")[0]
//       const _newNavbarHeight = _newNavbar.clientHeight

//       const _navbar = document.getElementsByClassName("navbar")[0]
//       const _navbarHeight = _navbar.clientHeight

//       const _planMapDoc = document.getElementsByClassName("Plan-Map")[0]
//       _planMapDoc.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30 -30 - 20) + 'px'


//       const _planDay = document.getElementsByClassName("Plan-Day")[0]
//       _planDay.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 20) + 'px'

//       const _leftDay = document.getElementsByClassName("Left-Day")[0]
//       _leftDay.style.height = (_bodyHeight - _newNavbarHeight - _navbarHeight - 30) + 'px'

//       const _planBudget = document.getElementsByClassName("Plan-Budget")[0]
//       _planBudget.style.maxHeight = (_bodyHeight - _newNavbarHeight - _navbarHeight - 20) + 'px'
//       // 创建地图实例  个性化地图遵照官网步骤
//       let map;
//         let script = document.createElement("script");
//         script.type = "text/javascript";
//         script.src = "http://api.map.baidu.com/api?v=2.0&ak=a9y3iTqqR1fleuqK57V3LVvatISVWdPa";

//         let script1 = document.createElement("script");
//         script1.type = "text/javascript";
//         script1.src = "https://api.map.baidu.com/getscript?type=webgl&v=1.0&ak=a9y3iTqqR1fleuqK57V3LVvatISVWdPa&services=&t=20241025145639";
//       if (!this.planMap) {
//           this.planMap = new BMapGL.Map("baidu-map");
//       }
//       map = this.planMap
//       map.clearOverlays();
//       // 创建中心点
//       let _find = this.checkBudgets.cityList[this.cityIndex]
//       const point = new BMapGL.Point(_find.longitude,_find.latitude);
//       // 初始化地图，设置中心点坐标和地图级别
//       map.centerAndZoom(point, 17);
//       //开启鼠标滚轮缩放
//       map.enableScrollWheelZoom(true);
//       //this.cover(map);
//       // map.enableBizAuthLogo(); //开启

//       // 控件类型（百度地图自带的） 自定义控件遵照官网平时比较少用到
//       // type: BMAP_NAVIGATION_CONTROL_SMALL 平移缩放控件的类型 const opts = {type: BMAP_NAVIGATION_CONTROL_SMALL}
//       // const opts = {anchor: BMAP_ANCHOR_TOP_RIGHT, offset: new BMapGL.Size(100, 10)}; // 偏移量
//       // map.addControl(new BMapGL.NavigationControl({anchor: BMAP_ANCHOR_TOP_RIGHT})); // PC端默认位于地图左上方，它包含控制地图的平移和缩放的功能。移动端提供缩放控件，默认位于地图右下方
//       map.addControl(new BMapGL.ScaleControl()); // 默认位于地图左下方，显示地图的比例关系
//       // // map.addControl(new BMap.OverviewMapControl()); // 默认位于地图右下方，是一个可折叠的缩略地图
//       // // map.addControl(new BMap.MapTypeControl({anchor: BMAP_ANCHOR_TOP_LEFT})); // 地图类型
//       // map.addControl(new BMapGL.CopyrightControl(opts)); // 默认位于地图左下方
//       // map.setMapStyleV2({
//       //   styleId: '870546eab641262129ced1fd21d450a3'
//       // });

//       // 标注（自定义标注图标 默认是类似尖头圆形红点---可以放置自己图片） 默认情况下标注不支持拖拽
//       //const marker = new BMap.Marker(point); // 创建标注
//       // const marker = new RadarOverlay(point,stateMap);
//       // map.addOverlay(marker); // 将标注添加到地图中
//       //跳转到那个中心点
//       // map.setCenter(point);
//       // marker.addEventListener("click", function(){
//       //   alert("您点击了点标注");
//       // })
//       // // 支持拖拽
//       // // marker.enableDragging();
//       // marker.addEventListener("dragend", function(e){
//       //   alert("当前位置：" + e.point.lng + ", " + e.point.lat);
//       // })
//       map.addEventListener("dragend", () => {
//         console.log("dragend")
//         // const center = map.getCenter();
//         this._getStockList(this.cityIndex,this.stateMap.state,'')
//         //alert("地图中心点变更为：" + center.lng + ", " + center.lat);
//       })
//       map.addEventListener("zoomend", (e) => {
//         console.log("zoomend")
//         this._getStockList(this.cityIndex,this.stateMap.state,'')
//       })
//     },
//     //缩放等级与比例尺的关系
//     // 根据地图缩放比例获取当前地图比例尺
//     getMapScale(zoom) {
//       let scale = 0;
//       switch (zoom) {
//         case 1:
//           scale = 10000000;
//           break;
//         case 2:
//           scale = 5000000;
//           break;
//         case 3:
//           scale = 2000000;
//           break;
//         case 4:
//           scale = 1000000;
//           break;
//         case 5:
//           scale = 500000;
//           break;
//         case 6:
//           scale = 200000;
//           break;
//         case 7:
//           scale = 100000;
//           break;
//         case 8:
//           scale = 50000;
//           break;
//         case 9:
//           scale = 25000;
//           break;
//         case 10:
//           scale = 20000;
//           break;
//         case 11:
//           scale = 10000;
//           break;
//         case 12:
//           scale = 5000;
//           break;
//         case 13:
//           scale = 2000;
//           break;
//         case 14:
//           scale = 1000;
//           break;
//         case 15:
//           scale = 500;
//           break;
//         case 16:
//           scale = 200;
//           break;
//         case 17:
//           scale = 100;
//           break;
//         case 18:
//           scale = 50;
//           break;
//         case 19:
//           scale = 20;
//           break;
//         default:
//           scale = 0;
//           break;
//       }
//       return scale;
//     }
//   },
//   // 生命周期 - 创建完成（可以访问当前this实例）
//   created() {
//       alert(1)
//       initMap()
//   },
//   // 生命周期 - 挂载完成（可以访问DOM元素）
//   mounted() {
//   },
//   beforeCreate() {}, // 生命周期 - 创建之前
//   beforeMount() {}, // 生命周期 - 挂载之前
//   beforeUpdate() {}, // 生命周期 - 更新之前
//   updated() {}, // 生命周期 - 更新之后
//   beforeDestroy() {
//     if (this.planMap) {
//       this.planMap.destroy()
//       this.planMap = null
//     }
//   }, // 生命周期 - 销毁之前
//   destroyed() {}, // 生命周期 - 销毁完成
//   activated() {}, // 如果页面有keep-alive缓存功能，这个函数会触发
// }
</script>
<style>
 .BMap_cpyCtrl {
  z-index: 1 !important;
 }
</style>
<style scoped lang="scss">
  .Baidu-Map {
    width: auto;
    .Plan-Map {
      width: auto;
      // height: 500px;
    }
}
</style>
